module.exports = __webpack_public_path__ + "static/AsraAlFauziMDPhD-dd9ab59478b513253fad0a71a1cd8ee6.jpg";